// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "HeroSection-module--wrapper--X0Lct";
export var cardWrapper = "HeroSection-module--cardWrapper--GpgGB";
export var educationList = "HeroSection-module--educationList--JVwKZ";
export var title = "HeroSection-module--title--rzj9M";
export var deliveredBy = "HeroSection-module--deliveredBy--NZY7L";
export var year = "HeroSection-module--year--iFeVe";
export var simpleList = "HeroSection-module--simpleList--VGFrf";
export var bigTriangle = "HeroSection-module--bigTriangle--fXgF5";
export var smallTriangle = "HeroSection-module--smallTriangle--kQZAl";
export var circleDecorator = "HeroSection-module--circleDecorator--cT0+h";
export var roundedSquareDecorator = "HeroSection-module--roundedSquareDecorator--ZaAK8";